// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://mara.nbg1.your-objectstorage.com/public';
const server = "https://apidonamara.mansolutions.app";
const port = 443;
const domain = "donamara.mansolutions.app";
export { server, port, domain, serverImg };
